import React, { useState } from 'react'
import { Panel } from '../Panel'
import styles from './EditorSection.module.scss'

/**
 * One labelled, collapsible group of fields in a widget editor.
 *
 * Panel.Header already renders the chevron and handles the click; it
 * deliberately leaves body visibility to the caller, so this owns that bit of
 * state and nothing else. Optional groups pass defaultCollapsed when they hold
 * nothing, which keeps the form short on open without ever hiding configured
 * content.
 */
interface EditorSectionProps {
  title: string
  /** Chip beside the title — a count, or a short status. */
  badge?: React.ReactNode
  /** Folded on first render. Author toggles win from then on. */
  defaultCollapsed?: boolean
  children: React.ReactNode
}

const EditorSection: React.FC<EditorSectionProps> = ({
  title,
  badge,
  defaultCollapsed = false,
  children,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  return (
    <Panel padding="none" className={styles.section}>
      <Panel.Header
        className={styles.header}
        variant="secondary"
        size="sm"
        collapsible
        collapsed={collapsed}
        onCollapsedChange={setCollapsed}
        trailing={badge}
      >
        {title}
      </Panel.Header>
      {!collapsed && (
        <Panel.Body className={styles.body}>{children}</Panel.Body>
      )}
    </Panel>
  )
}

export default EditorSection
